import axios from "axios";

const API_URL = "https://ims.holdthechild.net"; 

// ------------------------- REQUESTS -------------------------
export const fetchRequests = async (token) => {
  try {
    const res = await axios.get(`${API_URL}/api/requests`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to fetch requests:", error.response?.data || error.message);
    throw error;
  }
};

export const createRequest = async (requestData, token) => {
  try {
    const res = await axios.post(`${API_URL}/api/requests`, requestData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to create request:", error.response?.data || error.message);
    throw error;
  }
};

export const getRequestById = async (id, token) => {
  try {
    const res = await axios.get(`${API_URL}/api/requests/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to get request:", error.response?.data || error.message);
    throw error;
  }
};

// ------------------------- ISSUES -------------------------
export const fetchIssues = async (token) => {
  try {
    const res = await axios.get(`${API_URL}/api/issues`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to fetch issues:", error.response?.data || error.message);
    throw error;
  }
};

export const reportIssue = async (issueData, token) => {
  try {
    const res = await axios.post(`${API_URL}/api/issues`, issueData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to report issue:", error.response?.data || error.message);
    throw error;
  }
};

// ------------------------- EQUIPMENTS -------------------------
export const fetchEquipment = async (token) => {
  try {
    const res = await axios.get(`${API_URL}/api/equipment`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to fetch equipment:", error.response?.data || error.message);
    throw error;
  }
};

// ------------------------- FORM REQUESTS -------------------------
export const fetchFormRequests = async (token) => {
  try {
    const res = await axios.get(`${API_URL}/api/form-requests`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to fetch form requests:", error.response?.data || error.message);
    throw error;
  }
};

export const createFormRequest = async (formData, token) => {
  try {
    const res = await axios.post(`${API_URL}/api/form-requests`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to create form request:", error.response?.data || error.message);
    throw error;
  }
};
